import { type StateCreator } from 'zustand';

export type CanvasPopoverStatus = 'shown' | 'dismissed';

export type CanvasPopoverEntry = {
  status: CanvasPopoverStatus;
};

export type CanvasPopoverSlice = {
  canvasPopover: Record<string, CanvasPopoverEntry>;
  markCanvasPopoverShown: (workspaceId: string) => void;
  dismissCanvasPopover: (workspaceId: string) => void;
};

export const createCanvasPopoverSlice: StateCreator<CanvasPopoverSlice, [], [], CanvasPopoverSlice> = (set) => ({
  canvasPopover: {},
  markCanvasPopoverShown: (workspaceId) =>
    set((state) => ({ canvasPopover: { ...state.canvasPopover, [workspaceId]: { status: 'shown' } } })),
  dismissCanvasPopover: (workspaceId) =>
    set((state) => ({ canvasPopover: { ...state.canvasPopover, [workspaceId]: { status: 'dismissed' } } })),
});
